// istanbul ignore next
/**
 * Helper function to reload the current web page.
 */
export const doReload = (): void => {
  window.location.reload();
};
